export const ADMIN_BASE_URL = "/sanarip-tamga";
export const CURRENCIES = ["KGS", "USD", "EUR", "RUB"];
export const EMAILJS_SERVICE_ID = "service_2j3yfuq";
export const EMAILJS_TEMPLATE_ID = "template_wkv3zoo";
export const EMAILJS_PUBLIC_KEY = "7myWA4EMInfUldXbv";
